import { z } from "zod";

export const bankAccountType = () => z.enum(["checking", "savings"]);
